const SUBSCRIPTIONS = {
    none: 'none',
    basic: 'basic',
    pro: 'pro',
    growth: 'growth',
    premium: 'premium'
}
const UPGRADE_REASONS = ['Host more Events.', 'Reduced Fees.', 'More Marketing Tools.']
import { VENUE_PLANS, VENUE_PLAN_NAMES, ARTIST_PLANS } from './plans'

export { VENUE_PLANS, VENUE_PLAN_NAMES, ARTIST_PLANS, UPGRADE_REASONS }
export default SUBSCRIPTIONS
